<template>
	<div class="hit-container">
		<h1 class="hit-html-h1">{{ $t('message.privacy') }}</h1>

			<div class="hit-form-group" v-html="privacy" />

	</div>
</template>
<script>

import de from 'raw-loader!@shared/language/privacy/de_DE.txt'

var privacy = {
  'de': ''
}

privacy.de = de

export default {

  name: 'privacy',
  data () {
    var lang = this.$route.params.lang

    if (typeof privacy[lang] !== 'string') { lang = 'de' }

    return {
      privacy: this.$nl2br(privacy[lang])
    }
  }

}
</script>

<style scoped>

</style>
